import OnboardingPage from "../../common/components/OnboardingPage";
import { REWARD_OFFERING } from "../../constants";
import { getRedeemUrlWithContext } from "../../utils";

function OriginEnergyMain() {
  const redeemUrl = getRedeemUrlWithContext("origin-energy");

  return (
    <>
        <OnboardingPage
          redeemUrl={redeemUrl}
          rewardId={REWARD_OFFERING.originenergy}
        />
    </>
  );
}

export default OriginEnergyMain;
